import { createStore } from 'vuex'

export default createStore({
  state: {
  },
  getters: {
    isZH_CN() {
      return (navigator.language || '').indexOf('zh') === 0
    },
    isWeiXin() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    isDingTalk() {
      return /DingTalk/i.test(navigator.userAgent);
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
